import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./sngabout.css"


const SNGabout = ( { }) => {

    
    
    return (
        <section className="sngabout" id="SNGabout">
            <div className="containfix">
                <p className="underheader">
                    <span className="purplefy">The SNG Live Virtual Speaker Series</span>, presented by Scoop News Group, is an opportunity to hear perspectives from today’s forward-thinking IT leaders. SNG Live are virtual discussions with hand-selected IT decision makers and influencers who are on the front lines of transformation in their agency.
                </p>
            </div>
         </section>
    )
}

export default SNGabout